import type { MailRowRouteParameters } from './mailRowRouteHandler';
import mailRowFolderRouteHandler from './mailRowRouteHandler';
import { lazyForceCloseSxS, lazyOnPendingNavigation, getActiveSxSId } from 'owa-sxs-store';

export interface MailSxSRouteParameters extends MailRowRouteParameters {
    itemId: string;
    attachmentId: string;
}

export async function mailSxSNavigationRoutehandler(
    parameters: MailSxSRouteParameters
): Promise<void> {
    mailRowFolderRouteHandler(parameters);
    const onPendingNavigation = await lazyOnPendingNavigation.import();
    const sxsId: string | null = getActiveSxSId(window);
    onPendingNavigation(parameters.attachmentId, sxsId);
}

export async function mailSxSCleanupRouteHandler(
    _oldRoute?: string[],
    /* eslint-disable-next-line owa-custom-rules/no-optional-any-parameter -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE! This code should be fixed by any developer touching this code
     *	> Optional function parameters should not have type "any". This can hide undefined/null references otherwise detectable by the transpiler. */
    _oldParameters?: any,
    newRoute?: string[],
    /* eslint-disable-next-line owa-custom-rules/no-optional-any-parameter -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE! This code should be fixed by any developer touching this code
     *	> Optional function parameters should not have type "any". This can hide undefined/null references otherwise detectable by the transpiler. */
    _newParameters?: any
): Promise<boolean> {
    const stillInSxS = !!newRoute && newRoute.some(value => value == 'sxs');
    if (!stillInSxS) {
        const sxsId: string | null = getActiveSxSId(window);
        const forceCloseSxS = await lazyForceCloseSxS.import();
        forceCloseSxS('browserNavigation', sxsId);
    }

    return false;
}
